import { slideUp, slideDown } from "./slide";

export const navHover = (options = {}) => {
  const navTargets = document.querySelectorAll(".js-nav-hover");

  const toggleActive = (target, list) => {
    list.forEach((element) => {
      if (element !== target) {
        element.classList.remove("is_active");
      }
    });

    if (!target.classList.contains("is_active")) {
      target.classList.add("is_active");
    }
  };

  const removeActive = (targets) => {
    targets.forEach((element) => {
      element.classList.remove("is_active");
    });
  };

  navTargets.forEach((nav) => {
    const hoverParents = nav.querySelectorAll("[data-hover]");

    hoverParents.forEach((element) => {
      element.addEventListener("mouseover", () => {
        toggleActive(element, hoverParents);
      });
    });

    nav.addEventListener("mouseover", () => {
      nav.classList.add("is_hover");
    });

    nav.addEventListener("mouseleave", () => {
      nav.classList.remove("is_hover");
      removeActive(hoverParents);
    });
  });
};
